import { Box, Heading as ChakraHeading, Text } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'

interface SignUpHeadingProps {
  title?: string
  stepBackTitle: string
  onStepBackClick?: () => void
  caption?: string
}

const SignUpHeading = ({
  title,
  onStepBackClick,
  stepBackTitle,
  caption,
}: SignUpHeadingProps) => {
  const { t } = useTranslation('common')

  return (
    <>
      <Box h="20px" mt="56px" fontSize="14px" color="brand.wildBlueYonder">
        {onStepBackClick && (
          <Text
            as="button"
            fontFamily="proxima Nova Semibold"
            onClick={onStepBackClick}
          >
            &#10229; {stepBackTitle}
          </Text>
        )}
      </Box>
      <ChakraHeading
        fontFamily="Cocogoose Pro"
        mt="43px"
        fontSize="3xl"
        lineHeight="9"
        color="brand.ultramarine"
        mb={4}
      >
        {title || t('VENUE_PAGE_TEXT4')}
      </ChakraHeading>
      {caption && (
        <Text
          color="brand.americanBlue"
          fontSize="14px"
          lineHeight="5"
          textAlign="center"
        >
          {caption}
        </Text>
      )}
    </>
  )
}

export default SignUpHeading
